(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 12454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./styles/theme/theme.tsx
var theme = __webpack_require__(6412);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components-pages/home/cover/index.tsx





var Logo = (0,styled/* default */.ZP)(Avatar/* default */.Z)(function (_ref) {
  var theme = _ref.theme;
  return (0,defineProperty/* default */.Z)({
    width: 440,
    height: "auto",
    objectFit: "contain",
    margin: "0 auto"
  }, theme.breakpoints.down("sm"), {
    width: 340
  });
});

function Cover() {
  var isMobile = (0,useMediaQuery/* default */.Z)(theme/* default.breakpoints.down */.Z.breakpoints.down("sm"));
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      position: "relative",
      padding: "40px 0 0 0",
      marginBottom: 0,
      zIndex: 1,
      backgroundColor: "var(--color-brand-cream-primary)"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      backgroundColor: "#aa9d89",
      width: "100%",
      height: {
        xs: 360,
        sm: 450
      },
      borderRadius: {
        xs: 0,
        sm: "0 0 0 200px"
      },
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 2
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      width: {
        xs: "100%",
        sm: "85%"
      },
      height: {
        xs: 380,
        sm: 500,
        md: 600
      },
      borderRadius: "60px",
      overflow: "hidden",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundImage: "url('/images/image-optimize/living.webp')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      margin: "0 auto",
      position: "relative",
      zIndex: 3
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Logo, {
    src: isMobile ? "/images/v2/logos/10.png" : "/images/v2/logos/9.png",
    alt: "Logo Re/max",
    variant: "square"
  }))));
}

/* harmony default export */ var cover = (Cover);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./shared/components/contact-dialog/index.tsx
var contact_dialog = __webpack_require__(44135);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./shared/models/functions/HGetKeyFormEnum.ts
function generateEnumsFromKeys(obj) {
  return Object.keys(obj).reduce(function (enums, key) {
    enums[key] = key;
    return enums;
  }, {});
}

var HGetKeyFormEnum = function HGetKeyFormEnum(obj) {
  return generateEnumsFromKeys(obj);
};

/* harmony default export */ var functions_HGetKeyFormEnum = (HGetKeyFormEnum);
// EXTERNAL MODULE: ./lang/index.ts
var lang = __webpack_require__(62659);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./shared/components/footer/components/subscription-form/util/subscriptionForm.ts


 // Mapeamos los idiomas disponibles con sus traducciones específicas

var translations = {
  en: lang.en.SubscriptionForm,
  es: lang.es.SubscriptionForm
};

/**
 * createSubscriptionFormSchema
 * Genera el esquema Yup para el formulario de suscripción tomando los textos
 * correspondientes al idioma indicado (‵es‵ por defecto).
 */
var createSubscriptionFormSchema = function createSubscriptionFormSchema() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "es";
  var t = translations[locale];
  return es/* object */.Ry({
    email: es/* string */.Z_().email(t.form.error.email.invalid).required(t.form.error.email.required)["default"](""),
    name: es/* string */.Z_().required(t.form.error.name.required)["default"](""),
    interests: es/* array */.IX().of(es/* string */.Z_()).required(t.form.error.interests.required)["default"]([]),
    captcha: es/* string */.Z_().required(t.form.error.captcha.required)["default"]("")
  });
}; // Exportamos el esquema en idioma ES por defecto para no romper la API actual


var subscriptionFormSchema = createSubscriptionFormSchema();
/* harmony default export */ var subscriptionForm = ((/* unused pure expression or super */ null && (subscriptionFormSchema)));

var SubscriptionFormDefaultValues = {
  email: "",
  name: "",
  interests: [],
  captcha: ""
};
var SubscriptionFormKeyEnum = functions_HGetKeyFormEnum(SubscriptionFormDefaultValues);

// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
;// CONCATENATED MODULE: ./shared/models/endpoits/newsletter.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var NewsletterStatic; // /v2/newsletter-subscription

(function (NewsletterStatic) {
  NewsletterStatic["Subscription"] = "/v2/newsletter-subscription";
})(NewsletterStatic || (NewsletterStatic = {}));

var NewsletterEndpoints = _objectSpread({}, NewsletterStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/newsletter.request.ts




var postSubscription = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var email, name, interests, captcha;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            email = _ref.email, name = _ref.name, interests = _ref.interests, captcha = _ref.captcha;
            return _context.abrupt("return", (0,base_services_request/* postRequest */.j0)(NewsletterEndpoints.Subscription, {
              email: email,
              name: name,
              interests: interests,
              "g-recaptcha-response": captcha,
              lists: [2]
            }).then(function (response) {
              return response.data;
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function postSubscription(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./shared/models/functions/cath-error-server.ts
var cath_error_server = __webpack_require__(41619);
;// CONCATENATED MODULE: ./shared/components/footer/components/subscription-form/hooks/useSubscription.ts







var initialState = {
  body: "",
  title: "",
  isError: false
};

var postData = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
    var response;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return postSubscription(values);

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function postData(_x) {
    return _ref.apply(this, arguments);
  };
}();

var useSubscriptionForm = function useSubscriptionForm() {
  var _useState = (0,react.useState)(initialState),
      message = _useState[0],
      setMessage = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var translationAlert = (0,next_intl_cjs_production_min.useTranslations)("alerts.subscription");

  var handleMessage = function handleMessage(data) {
    setMessage(data);
    setIsOpen(true);
  };

  var _useMutation = (0,useMutation/* useMutation */.D)(postData, {
    onSuccess: function onSuccess(data) {
      handleMessage({
        title: translationAlert("titleSuccess"),
        body: (data === null || data === void 0 ? void 0 : data.message) || "",
        isError: false
      });
    },
    onError: function onError(e) {
      var title = translationAlert("titleError");
      handleMessage({
        title: title,
        body: (0,cath_error_server/* HCatchServerError */.i)(e.response.data),
        isError: true
      });
    }
  }),
      mutateAsync = _useMutation.mutateAsync,
      isLoading = _useMutation.isLoading;

  return {
    mutateAsync: mutateAsync,
    isLoading: isLoading,
    message: message,
    isOpen: isOpen,
    setIsOpen: setIsOpen
  };
};
// EXTERNAL MODULE: ./shared/components/message-modal/index.tsx
var message_modal = __webpack_require__(36481);
// EXTERNAL MODULE: ./custom-hooks/data-layer-event.hook.ts
var data_layer_event_hook = __webpack_require__(65198);
;// CONCATENATED MODULE: ./shared/components/footer/components/subscription-form/SubcriptionForm.tsx




var _templateObject;












 // Añadimos intervalo de refresco automático del captcha (tokens ~2min)


var CAPTCHA_REFRESH_INTERVAL_MS = 110000; // 1m50s

var SubscriptionForm = function SubscriptionForm() {
  var _errors$interests;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var t = (0,next_intl_cjs_production_min.useTranslations)("SubscriptionForm");
  var schema = createSubscriptionFormSchema(locale);

  var _useState = (0,react.useState)(false),
      refreshCaptcha = _useState[0],
      setRefreshCaptcha = _useState[1];

  var _useDataLayerEvent = (0,data_layer_event_hook/* default */.Z)(),
      event = _useDataLayerEvent.event;

  var _useForm = (0,index_esm/* useForm */.cI)({
    defaultValues: SubscriptionFormDefaultValues,
    resolver: (0,yup/* yupResolver */.X)(schema)
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      setValue = _useForm.setValue,
      errors = _useForm.formState.errors;

  var _useSubscriptionForm = useSubscriptionForm(),
      mutateAsync = _useSubscriptionForm.mutateAsync,
      isLoading = _useSubscriptionForm.isLoading,
      message = _useSubscriptionForm.message,
      isOpen = _useSubscriptionForm.isOpen,
      setIsOpen = _useSubscriptionForm.setIsOpen;

  (0,react.useEffect)(function () {
    var interval = setInterval(function () {
      setRefreshCaptcha(function (prev) {
        return !prev;
      });
    }, CAPTCHA_REFRESH_INTERVAL_MS);
    return function () {
      return clearInterval(interval);
    };
  }, []);

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data, e) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setRefreshCaptcha(function (prev) {
                return !prev;
              });
              _context.next = 3;
              return mutateAsync(data).then(function (res) {
                event({
                  event_name: "newsletter_subscription",
                  body: {
                    email: data.email,
                    name: data.name,
                    interests: data.interests
                  }
                });
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var optionsCheck = [{
    label: t("form.options.marketing"),
    value: "1"
  }, {
    label: t("form.options.sector"),
    value: "2"
  }, {
    label: t("form.options.finance"),
    value: "3"
  }, {
    label: t("form.options.news"),
    value: "4"
  } // {
  //   label: t("form.options.others"),
  //   value: "5",
  // },
  ];
  var handleVerify = (0,react.useCallback)(function (token) {
    setValue(SubscriptionFormKeyEnum.captcha, token, {
      shouldValidate: true
    });
  }, [setValue]);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(CustomForm, {
    onSubmit: handleSubmit(onSubmit)
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(message_modal/* ModalMessage */.P, (0,esm_extends/* default */.Z)({}, message, {
    variant: message.isError ? "error" : "success",
    open: isOpen,
    buttonText: "OK",
    handleClose: function handleClose() {
      return setIsOpen(false);
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "input-form-container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("label", {
    className: "input-form-label",
    htmlFor: SubscriptionFormKeyEnum.email
  }, t("form.field.email")), (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({}, register(SubscriptionFormKeyEnum.email), {
    type: "email",
    placeholder: t("form.field.email"),
    className: "input-form"
  })), errors.email && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "input-form-error"
  }, errors.email.message)), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "input-form-container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("label", {
    className: "input-form-label",
    htmlFor: SubscriptionFormKeyEnum.name
  }, t("form.field.name")), (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({}, register(SubscriptionFormKeyEnum.name), {
    type: "text",
    placeholder: t("form.field.name"),
    className: "input-form"
  })), errors.name && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "input-form-error"
  }, errors.name.message)), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "input-form-container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("label", {
    className: "input-form-label",
    htmlFor: SubscriptionFormKeyEnum.interests
  }, t("form.field.interests")), optionsCheck.map(function (option, index) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
      key: index,
      className: "input-form-checkbox"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({}, register(SubscriptionFormKeyEnum.interests), {
      type: "checkbox",
      value: option.value
    })), (0,emotion_react_browser_esm/* jsx */.tZ)("label", {
      htmlFor: option.value
    }, option.label));
  }), errors.interests && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "input-form-error"
  }, (_errors$interests = errors.interests) === null || _errors$interests === void 0 ? void 0 : _errors$interests.message)), (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({
    type: "hidden"
  }, register(SubscriptionFormKeyEnum.captcha))), (0,emotion_react_browser_esm/* jsx */.tZ)(react_google_recaptcha_v3_esm/* GoogleReCaptcha */.mP, {
    onVerify: handleVerify,
    refreshReCaptcha: refreshCaptcha
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
    type: "submit",
    className: "input-form-submit",
    disabled: isLoading
  }, isLoading ? t("form.field.submit_loading") : t("form.field.submit")));
};

/* harmony default export */ var SubcriptionForm = (SubscriptionForm);
var CustomForm = (0,styled/* default */.ZP)("form")(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  .input-form-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    .input-form {\n      width: 100%;\n      padding: 0.7rem;\n      border: 1px solid #ccc;\n      border-radius: 0.5rem;\n    }\n    .input-form-label {\n      font-size: 0.8rem;\n      font-weight: 500;\n      color: white;\n\n      &:after {\n        content: \" *\";\n        color: var(--color-brand-red-main);\n        margin-right: 0.1rem;\n      }\n    }\n    .input-form-error {\n      color: var(--color-brand-red-main);\n      font-size: 0.8rem;\n      font-weight: 400;\n    }\n  }\n\n  .input-form-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    label {\n      font-size: 0.8rem;\n      font-weight: 400;\n      color: white;\n    }\n  }\n  .input-form-submit {\n    background-color: var(--color-brand-red-main);\n    color: white;\n    border: none;\n    padding: 0.7rem;\n    border-radius: 0.5rem;\n    cursor: pointer;\n    font-size: 0.8rem;\n    font-weight: 600;\n    max-width: 100px;\n  }\n"])));
;// CONCATENATED MODULE: ./shared/components/footer/components/form.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





function FormFooter() {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(form_CustomForm, {
    className: "subscribe-blog-hubspot-remaxrd"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(SubcriptionForm, null));
}

/* harmony default export */ var components_form = (FormFooter);

var form_CustomForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xkjbh30"
} : 0)( true ? {
  name: "rv9a66",
  styles: "margin-top:1rem;padding:\"0px 5px\";& .subscribe{color:white;margin:40px 0;padding:0px 5px;color:var(--color-brand-bg-secondary);font-size:var(--fs-body-smaller);font-weight:400;line-height:15px;}& button{background-color:#fff;color:#1b2e57;border:none;outline:none;margin-top:10px;padding:9px 20px;border-radius:50px;cursor:pointer;font-style:normal;font-weight:700;font-size:9px;line-height:10px;text-align:center;color:var(--color-brand-blue-main);max-width:120px;min-width:120px;height:36px;vertical-align:top;@media screen and (max-width: 991px){&{margin-top:0;}}@media screen and (max-width: 787px){&{align-self:flex-start;margin-top:10px;}}}"
} : 0);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
;// CONCATENATED MODULE: ./shared/components-pages/home/remax-v2-action-sections/index.tsx


var remax_v2_action_sections_templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;











function RemaxV2ActionSections() {
  var t = (0,next_intl_cjs_production_min.useTranslations)("home.remaxV2");

  var _useState = (0,react.useState)(false),
      openContact = _useState[0],
      setOpenContact = _useState[1];

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ActionBand, {
    className: "tone-red agent-band"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BandInner, {
    className: "agent-layout"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BandCopy, null, (0,emotion_react_browser_esm/* jsx */.tZ)(BandTitle, null, t("agent.title")), (0,emotion_react_browser_esm/* jsx */.tZ)(BandText, null, t("agent.description")), (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.join */.K.es.join,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    bg: "--color-brand-blue-main"
  }, t("agent.button")))), (0,emotion_react_browser_esm/* jsx */.tZ)(SoftEdgeImageFrame, {
    className: "blend-red agent-photo-frame"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BandImage, {
    className: "agent-photo soft-edge-photo",
    src: "/images/v2/pic/image-02.jpeg",
    alt: t("agent.title")
  })))), (0,emotion_react_browser_esm/* jsx */.tZ)(ActionBand, {
    className: "tone-cream"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BandInner, {
    className: "reverse"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(SoftEdgeImageFrame, {
    className: "blend-cream"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BandImage, {
    className: "soft-edge-photo",
    src: "/images/image-optimize/franchises.webp",
    alt: t("franchise.title")
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(BandCopy, null, (0,emotion_react_browser_esm/* jsx */.tZ)(BandTitle, null, t("franchise.title")), (0,emotion_react_browser_esm/* jsx */.tZ)(BandText, null, t("franchise.description")), (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.franchises */.K.es.franchises,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    bg: "--color-brand-red-main"
  }, t("franchise.button")))))), (0,emotion_react_browser_esm/* jsx */.tZ)(ActionBand, {
    className: "tone-blue"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BandInner, null, (0,emotion_react_browser_esm/* jsx */.tZ)(BandCopy, null, (0,emotion_react_browser_esm/* jsx */.tZ)(BandTitle, null, t("blog.title")), (0,emotion_react_browser_esm/* jsx */.tZ)(BandText, null, t("blog.description")), (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    href: pages_path/* CPagesPath.blog */.K.blog,
    target: "_blank",
    rel: "noopener noreferrer",
    bg: "--color-brand-red-main"
  }, t("blog.button"))), (0,emotion_react_browser_esm/* jsx */.tZ)(BlogFormColumn, null, (0,emotion_react_browser_esm/* jsx */.tZ)(components_form, null)))), (0,emotion_react_browser_esm/* jsx */.tZ)(ActionBand, {
    className: "tone-white"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BandInner, {
    className: "reverse"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(SoftEdgeImageFrame, {
    className: "blend-white"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BandImage, {
    className: "soft-edge-photo",
    src: "/images/image-optimize/franchise-agent-women.webp",
    alt: t("contact.title")
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(BandCopy, null, (0,emotion_react_browser_esm/* jsx */.tZ)(BandTitle, null, t("contact.title")), (0,emotion_react_browser_esm/* jsx */.tZ)(BandText, null, t("contact.description")), (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    type: "button",
    onClick: function onClick() {
      return setOpenContact(true);
    },
    bg: "--color-brand-blue-main"
  }, t("contact.button"))))), (0,emotion_react_browser_esm/* jsx */.tZ)(contact_dialog/* default */.Z, {
    open: openContact,
    onClose: function onClose() {
      return setOpenContact(false);
    },
    classNameModalButton: "enviar-formulario-contacto-home"
  }));
}

/* harmony default export */ var remax_v2_action_sections = (RemaxV2ActionSections);
var ActionBand = (0,styled/* default */.ZP)("section")(remax_v2_action_sections_templateObject || (remax_v2_action_sections_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  padding: 88px 6vw;\n  position: relative;\n  overflow: hidden;\n\n  &.tone-red {\n    background:\n      radial-gradient(\n        circle at 82% 8%,\n        rgba(0, 67, 255, 0.24) 0%,\n        rgba(0, 67, 255, 0) 30%\n      ),\n      linear-gradient(180deg, var(--color-brand-red-main) 0%, #d71108 100%);\n    color: var(--color-text-white);\n  }\n\n  &.agent-band {\n    padding-top: 72px;\n  }\n\n  &.tone-blue {\n    background-color: var(--color-brand-blue-main);\n    color: var(--color-text-white);\n  }\n\n  &.tone-cream {\n    background-color: var(--color-brand-cream-primary);\n    color: var(--color-text-black);\n  }\n\n  &.tone-white {\n    background-color: var(--color-brand-bg-secondary);\n    color: var(--color-text-black);\n  }\n\n  @media screen and (max-width: 768px) {\n    padding: 56px 20px;\n  }\n"])));
var BandInner = (0,styled/* default */.ZP)("div")(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 1180px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(280px, 500px);\n  gap: 56px;\n  align-items: center;\n\n  &.reverse {\n    grid-template-columns: minmax(280px, 500px) minmax(0, 1fr);\n  }\n\n  &.agent-layout {\n    grid-template-columns: minmax(0, 0.96fr) minmax(340px, 560px);\n    gap: 64px;\n  }\n\n  @media screen and (max-width: 900px) {\n    grid-template-columns: 1fr;\n    gap: 32px;\n\n    &.reverse {\n      grid-template-columns: 1fr;\n    }\n\n    &.agent-layout {\n      grid-template-columns: 1fr;\n      gap: 34px;\n    }\n  }\n"])));
var BandCopy = (0,styled/* default */.ZP)("div")(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 620px;\n\n  @media screen and (max-width: 900px) {\n    max-width: 100%;\n    text-align: center;\n  }\n"])));
var BandTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 2rem;\n  font-weight: 700;\n  line-height: 1.15;\n  margin-bottom: 18px;\n\n  @media screen and (max-width: 768px) {\n    font-size: 1.55rem;\n  }\n"])));
var BandText = (0,styled/* default */.ZP)(Typography/* default */.Z)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 1rem;\n  line-height: 1.75;\n  margin-bottom: 30px;\n  max-width: 590px;\n\n  @media screen and (max-width: 900px) {\n    margin-left: auto;\n    margin-right: auto;\n  }\n"])));
var SoftEdgeImageFrame = (0,styled/* default */.ZP)("div")(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  --soft-edge-bg: var(--color-brand-bg-secondary);\n  --soft-edge-rgb: 255, 255, 255;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  position: relative;\n  overflow: hidden;\n  background-color: transparent;\n  border-radius: 42px;\n\n  &.agent-photo-frame {\n    aspect-ratio: 16 / 10;\n  }\n\n  &.blend-cream {\n    --soft-edge-bg: var(--color-brand-cream-primary);\n    --soft-edge-rgb: 247, 245, 238;\n  }\n\n  &.blend-red {\n    --soft-edge-bg: var(--color-brand-red-main);\n    --soft-edge-rgb: 255, 18, 0;\n  }\n\n  &.blend-white {\n    --soft-edge-bg: var(--color-brand-bg-secondary);\n    --soft-edge-rgb: 255, 255, 255;\n  }\n\n  &::after {\n    content: none;\n  }\n\n  @media screen and (max-width: 900px) {\n    border-radius: 34px;\n\n    &.agent-photo-frame {\n      aspect-ratio: 1 / 1.08;\n      max-height: 420px;\n    }\n  }\n"])));
var BandImage = (0,styled/* default */.ZP)("img")(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n  border-radius: 0 90px 0 90px;\n\n  &.agent-photo {\n    aspect-ratio: 16 / 10;\n    object-position: 16% center;\n    border-radius: 42px;\n    box-shadow: 0 28px 70px rgba(0, 0, 0, 0.24);\n  }\n\n  &.soft-edge-photo {\n    height: 100%;\n    aspect-ratio: auto;\n    border-radius: 0;\n    box-shadow: none;\n    display: block;\n    -webkit-mask-image: radial-gradient(\n        ellipse at center,\n        #000 0%,\n        #000 44%,\n        rgba(0, 0, 0, 0.86) 56%,\n        rgba(0, 0, 0, 0.36) 70%,\n        transparent 86%\n      ),\n      linear-gradient(\n        90deg,\n        transparent 0%,\n        #000 22%,\n        #000 78%,\n        transparent 100%\n      ),\n      linear-gradient(\n        180deg,\n        transparent 0%,\n        #000 22%,\n        #000 78%,\n        transparent 100%\n      );\n    mask-image: radial-gradient(\n        ellipse at center,\n        #000 0%,\n        #000 44%,\n        rgba(0, 0, 0, 0.86) 56%,\n        rgba(0, 0, 0, 0.36) 70%,\n        transparent 86%\n      ),\n      linear-gradient(\n        90deg,\n        transparent 0%,\n        #000 22%,\n        #000 78%,\n        transparent 100%\n      ),\n      linear-gradient(\n        180deg,\n        transparent 0%,\n        #000 22%,\n        #000 78%,\n        transparent 100%\n      );\n    -webkit-mask-composite: source-in, source-in;\n    mask-composite: intersect;\n    -webkit-mask-repeat: no-repeat;\n    mask-repeat: no-repeat;\n    -webkit-mask-size: 100% 100%;\n    mask-size: 100% 100%;\n  }\n\n  @media screen and (max-width: 900px) {\n    max-height: 360px;\n\n    &.agent-photo {\n      aspect-ratio: 1 / 1.08;\n      max-height: 420px;\n      object-position: 10% center;\n      border-radius: 34px;\n    }\n\n    &.soft-edge-photo {\n      max-height: none;\n    }\n  }\n"])));
var BlogFormColumn = (0,styled/* default */.ZP)("div")(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-width: 520px;\n  margin-left: auto;\n\n  @media screen and (max-width: 900px) {\n    max-width: 100%;\n    margin: 0;\n  }\n"])));
// EXTERNAL MODULE: ./shared/components/head-meta/index.tsx
var head_meta = __webpack_require__(23385);
// EXTERNAL MODULE: ./shared/models/const/keywords.const.ts
var keywords_const = __webpack_require__(6644);
;// CONCATENATED MODULE: ./pages/index.tsx






var Home = function Home(props) {
  var metaData = {
    keyWords: keywords_const/* CKeyWordsPages.home */.k.home,
    description: "home",
    url: "/",
    title: "home",
    picture: "/images/image-optimize/living_meta.jpg"
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)(head_meta/* default */.Z, metaData), (0,emotion_react_browser_esm/* jsx */.tZ)(cover, null), (0,emotion_react_browser_esm/* jsx */.tZ)(remax_v2_action_sections, null));
};

var __N_SSG = true;
/* harmony default export */ var pages = (Home);

/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72717);
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);






function HeadMeta(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      og_type = props.og_type,
      picture = props.picture,
      canonical = props.canonical,
      keyWords = props.keyWords;
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("title-pages");
  var MetaDescriptionT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("metaDescriptions");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default()), null, title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", null, titleT(title)), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: description
  }), keyWords && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: keyWords
  }), url && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: "".concat("https://unete.remaxrd.com").concat(url)
  }), og_type && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: og_type
  }), title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: title
  }), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: MetaDescriptionT(description)
  }), picture && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: "https://unete.remaxrd.com" + picture
  }), (url || canonical) && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(canonical !== null && canonical !== void 0 ? canonical : url)),
    key: "canonical"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeadMeta);

/***/ }),

/***/ 6644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CKeyWordsPages; }
/* harmony export */ });
var CKeyWordsPages = {
  project: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana",
  join: "conviértete en agente inmobiliario remax, únete a remax república dominicana, agente inmobiliario remax, agencia inmobiliaria, agente inmobiliario, agente Remax",
  page404: "pagina no encontrada",
  home: "inmueble, remax rd, remax república dominicana, alquilar una casa, comprar una casa, comercialización de inmuebles, proyectos en construcción, beneficios de comprar en planos, préstamos hipotecarios, préstamos hipotecarios en república dominicana, franquicia remax, Propiedades destacadas, propiedades de Remax RD, propiedades de remax república dominicana, agente inmobliario, agencia inmobiliaria, propiedades en República Dominicana, alquiler apartamento, bienes raices santo domingo, departamentos en alquiler santo domingo, proyectos de apartamentos en punta cana, alquilar casa, apartamentos en santo domingo este, apartamentos en bavaro, apartamento en venta punta cana, apartamentos en rd, apartamentos en alquiler santo domingo este, proyectos de apartamentos económicos en santo domingo, apartamentos en venta san isidro, apartamentos en venta republica dominicana, apartamentos en alquiler en santo domingo distrito nacional, apartamento en alquiler, casas en alquiler en república dominicana, proyectos de apartamentos en santo domingo distrito nacional, venta de propiedades en republica dominicana, casas rd, venta de casas en santo domingo, apartamento en el millon, alquiler de apartamentos en santo domingo distrito nacional, comprar apartamento en santo domingo, compra de apartamentos en santo domingo, apartamentos en La Romana",
  homeCollections: "Remax collection, propiedades de lujo, propiedades exclusivas, propiedades premium, propiedades collection",
  mortgageLoad: "préstamo hipotecario, Calculadora de prestamos, cuota de préstamos hipotecarios, formulario de prestamos",
  iWantToRent: "casas en alquiler, villas en alquiler, townhouse en alquiler, apartamento en alquiler, oficinas en alquiler, almacén en alquiler, villas en alquiler, alquiler de aparta estudio, proyectos exclusivos de remax república dominicana",
  iWantToBuy: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana, compra inmobiliaria, adquir propiedad inmobiliaria, inversion inmobiliaria en república dominicana, inversión inmobiliaria"
};

/***/ }),

/***/ 41619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ HCatchServerError; }
/* harmony export */ });
var HCatchServerError = function HCatchServerError(response) {
  var _response$data, _response$data$data, _response$data3, _response$data3$data, _response$data5, _response$data6;

  if (response !== null && response !== void 0 && response.errors) {
    return Object.keys(response.errors).map(function (key) {
      return response.errors[key].join("\n");
    });
  }

  if (response !== null && response !== void 0 && response.message) {
    return response.message;
  }

  if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$data = _response$data.data) !== null && _response$data$data !== void 0 && _response$data$data.message) {
    var _response$data2, _response$data2$data;

    return response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$data = _response$data2.data) === null || _response$data2$data === void 0 ? void 0 : _response$data2$data.message;
  }

  if (response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && (_response$data3$data = _response$data3.data) !== null && _response$data3$data !== void 0 && _response$data3$data.error) {
    var _response$data4, _response$data4$data;

    return response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : (_response$data4$data = _response$data4.data) === null || _response$data4$data === void 0 ? void 0 : _response$data4$data.error;
  }

  if (response !== null && response !== void 0 && response.data) {
    if (response.data.message === "Page not found") {
      return "Url no Valida o paramentos no validos";
    }
  }

  if (response !== null && response !== void 0 && response.data) {
    if (response.data.message === "This action is unauthorized.") {
      return "Esta acción no está autorizada";
    }
  }

  if (response !== null && response !== void 0 && (_response$data5 = response.data) !== null && _response$data5 !== void 0 && _response$data5.errors) {
    var errors = response.data.errors;
    var message = "";

    for (var property in errors) {
      message += "".concat(errors[property], "\n");
    }

    return message;
  }

  if (response !== null && response !== void 0 && (_response$data6 = response.data) !== null && _response$data6 !== void 0 && _response$data6.message) {
    return response === null || response === void 0 ? void 0 : response.data.message;
  }

  return "Ups ha ocurrido un inconveniente";
};

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(12454);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7533,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);